import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC } from 'react';
import FormContainer from '../../Shared/FormContainer/FormContainer';
import LoadingSpinner from '../../Shared/LoadingSpinner/LoadingSpinner';
import { CenteredInfoContainer } from '../styled';
import { FORM_INFO_COMPONENT_TYPES } from '../types';
import { FormBody, FormInfoWrapper, ProssecingPayment } from './styled';

interface FormInfoFormsFilledProps {
  type: keyof typeof FORM_INFO_COMPONENT_TYPES;
  title: string;
  body: string;
  loading?: boolean;
  children?: React.ReactNode;
  aboveTitleElement?: React.ReactNode;
  error?: boolean;
}
const FormInfoFormsFilled: FC<FormInfoFormsFilledProps> = ({ type, title, body, loading, children, aboveTitleElement, error }) => {
  const { t } = useTranslation();
  const defaultTitle = t(FORM_INFO_COMPONENT_TYPES[type].title);
  const defaultBody = t(FORM_INFO_COMPONENT_TYPES[type].body);
  return (
    <FormInfoWrapper>
      <div>
        {loading && (
          <ProssecingPayment>
            <LoadingSpinner />
            <span>{t('formsFilled.processing')}</span>
          </ProssecingPayment>
        )}
        {!loading && !error && (
          <FormContainer title={title || defaultTitle} noNextButton noPreviousButton aboveTitleElement={aboveTitleElement} centerTitle>
            <CenteredInfoContainer>
              <FormBody>{body || defaultBody}</FormBody>
              {children}
            </CenteredInfoContainer>
          </FormContainer>
        )}

        {error && (
          <ProssecingPayment>
            <span>{t('formsFilled.defaultError')}</span>
          </ProssecingPayment>
        )}
      </div>
    </FormInfoWrapper>
  );
};

export default FormInfoFormsFilled;
